import { map, join } from 'lodash';

const GraphQLReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_ERROR':
            return {
                ...state,
                status: 'error',
                error: action.error
            };
        case 'GRAPHQL_ERROR':
            return {
                ...state,
                status: 'error',
                error: join(map(action.error, 'message'), '\n')
            };
        case 'GRAPHQL_SUCCESS':
            return {
                ...state,
                status: 'success',
                data: action.data
            };
        case 'FETCHING':
            return {
                ...state,
                status: 'fetching'
            };
        default:
            return state;
    }
};

export default GraphQLReducer;
